// @flow

import {
  GET_RESULTS_BEGIN,
  GET_RESULTS_SUCCESS,
  MORE_OPTIONS,
  RESULTS_PAGE_LOAD
} from './results/results';

import {
  SAVE_JOB_BEGIN,
  SAVE_JOB_SUCCESS,
  SAVE_JOB_ERROR
} from './savedJobs/savedJobs';

import { GET_ACCOUNT_SUCCESS, UPDATE_SESSION } from './user/user';

import {
  JOB_DETAILS_FETCH_BEGIN,
  JOB_DETAILS_FETCH_SUCCESS,
  JOB_EXPIRED,
  JOB_DETAILS_PAGE_LOADED,
  JOB_DETAILS_FETCH_FAILURE,
  JOB_APPLICATION_FETCH_START,
  JOB_APPLICATION_FETCH_SUCCESS
} from './jobdetails/jobdetails';

import { JOB_LIST_IMPRESSION } from './joblistitem/joblistitem';

import { HOME_PAGE_LOADED } from './home/home';
import { Actions as SeoActions } from './seo/seo';

import {
  GET_COUNTS_BEGIN,
  GET_COUNTS_SUCCESS,
  SUBMIT_SEARCH,
  UPDATE_CRITERIA,
  UPDATE_ACTIVE_REFINEMENT
} from './search/search';

import { LAST_SEARCH_UPDATED } from './lastSearch/lastSearch';
import { GET_LMIS_SUCCESS } from './lmis/lmis';
import { LOCATION_CHANGED, SET_PAGE_TITLE } from './location/location';
import { SAVED_JOBS_SEARCH_SUCCESS } from './savedJobs/savedJobs';
import { GET_DASHBOARD_SUCCESS } from './dashboard/dashboard';

const { GET_META_DESCRIPTION, SET_CANONICAL_URL } = SeoActions;

// These cannot be exported as POJOs because in causes circular
// dependencies and hence a race condition so using functions to access.
const transitions = {
  routeChange() {
    return {
      name: 'routeChange',
      allowedActions: [
        '@@REDUX_HOTJAR_QUEUE_TAGS',
        '__EXPERIMENTS_INITIALISED',
        GET_ACCOUNT_SUCCESS,
        GET_COUNTS_BEGIN,
        GET_COUNTS_SUCCESS,
        GET_DASHBOARD_SUCCESS,
        GET_LMIS_SUCCESS,
        GET_META_DESCRIPTION,
        GET_RESULTS_BEGIN,
        GET_RESULTS_SUCCESS,
        HOME_PAGE_LOADED,
        JOB_DETAILS_FETCH_BEGIN,
        JOB_DETAILS_FETCH_SUCCESS,
        JOB_DETAILS_FETCH_FAILURE,
        JOB_EXPIRED,
        JOB_DETAILS_PAGE_LOADED,
        JOB_APPLICATION_FETCH_START,
        JOB_APPLICATION_FETCH_SUCCESS,
        JOB_LIST_IMPRESSION,
        LAST_SEARCH_UPDATED,
        LOCATION_CHANGED,
        MORE_OPTIONS,
        RESULTS_PAGE_LOAD,
        SAVE_JOB_BEGIN,
        SAVE_JOB_SUCCESS,
        SAVE_JOB_ERROR,
        SAVED_JOBS_SEARCH_SUCCESS,
        SET_CANONICAL_URL,
        SET_PAGE_TITLE,
        SUBMIT_SEARCH,
        UPDATE_ACTIVE_REFINEMENT,
        UPDATE_CRITERIA,
        UPDATE_SESSION
      ]
    };
  }
};

export function getTransaction(transactionName: string) {
  const transitionFunc = transitions[transactionName];
  return transitionFunc();
}
